import { render, staticRenderFns } from "./ModalAlist.vue?vue&type=template&id=0fa0524e&scoped=true"
import script from "./ModalAlist.vue?vue&type=script&lang=js"
export * from "./ModalAlist.vue?vue&type=script&lang=js"
import style0 from "./ModalAlist.vue?vue&type=style&index=0&id=0fa0524e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0524e",
  null
  
)

export default component.exports